var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5H21L19 19.5L12.5 21.5L5.5 19.5L4 2.5Z",
    fill: "#E7A42B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.315 4L17.625 18.355L12.5 19.93V4H19.315Z",
    fill: "#F2BF22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 10.5L12.9995 11.5L12.4995 12.5H7.89453L8.31953 6H12.4995L12.9995 7L12.4995 8H10.5145L10.3495 10.5H12.4995Z",
    fill: "#FAF9F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4504 16.285L12.5004 16.27L13.0004 17.5L12.5004 18.36L12.4704 18.37L8.30539 17.18L8.02539 14H10.0354L10.1754 15.635L12.4504 16.285Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.035 10.5L16.25 17.21L12.5 18.36V16.27L14.415 15.68L14.785 12.5H12.5V10.5H17.035Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.46 9H15.465L15.335 8H12.5V6H17.065L17.15 6.63L17.46 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.9716c6ac1c19c526501cec15c92a2943.svg";
export { ForwardRef as ReactComponent };